import { DateHelper } from "@swivl-mono/helpers";
import { APIScope, MemberInviteInterface } from "@swivl-mono/types";
import { Button, ButtonColor, LayoutHeader } from "@swivl-mono/ui";
import { DateTime } from "luxon";
import { useEffect } from "react";

import { ShowIf } from "../../../../Components/ShowIf/ShowIf";
import LocationsModel from "../../../../Models/Locations/Locations.Model";
import MembersModel from "../../../../Models/Member/Members.Model";
import { AlertsModel } from "../../../../Models/Notifications/Alerts.Model";
import { MemberOrInvitePermissionsRole } from "./Role/MemberOrInvitePermissionsRole.View";

interface Props {
  invite: MemberInviteInterface;
}
export function InvitePermissionsView(props: Props) {
  const { invite } = props;
  useEffect(() => {
    LocationsModel.getGroupsAndLocations(false);
  }, []);

  return (
    <div className="flex flex-col px-6 pb-6">
      <LayoutHeader noPadding={true}>
        <h2>
          {invite.firstName} {invite.lastName}
          <label>PENDING INVITE</label>
        </h2>

        <ShowIf scope={APIScope.MEMBERS_SET}>
          <Button
            className="ml-2"
            onClickAsync={async () => {
              if (window.confirm("Are you sure you want to resend this invite?")) {
                MembersModel.resendInvite(invite)
                  .then(() => {
                    AlertsModel.successToast("Invite Resent");
                  })
                  .catch((e) => {
                    AlertsModel.errorToast("Error Resending Invite");
                  });
              }
            }}
          >
            Resend Invite
          </Button>
        </ShowIf>

        <ShowIf scope={APIScope.MEMBERS_SET}>
          <Button
            color={ButtonColor.WHITE}
            className="ml-2"
            onClickAsync={async () => {
              if (window.confirm("Are you sure you want to delete this invite?")) {
                MembersModel.deleteInvite(invite);
              }
            }}
          >
            Delete Invite
          </Button>
        </ShowIf>
      </LayoutHeader>

      <div className="flex flex-row items-center pb-3">
        <p className="font-semibold">Email:</p>
        <p className="pl-2">{invite.email}</p>
      </div>
      <div className="flex flex-row items-center pb-3">
        <p className="font-semibold">Sent by:</p>
        <p className="pl-2">
          {invite.sentByMember?.account.firstName} {invite.sentByMember?.account.lastName} @{" "}
          {DateHelper.dateTime(invite.createdAt).toLocaleString(DateTime.DATETIME_SHORT)}
        </p>
      </div>

      <h3 className="text-lg font-semibold text-grey-800">Permissions</h3>
      {!invite.permissions?.length ? (
        <div className="flex flex-row items-center pb-3">
          <p className="font-semibold">This member has no assigned roles.</p>
        </div>
      ) : (
        invite.permissions.map((permission) => <MemberOrInvitePermissionsRole invite={invite} memberPermission={permission} key={permission.id} />)
      )}
    </div>
  );
}
